import * as React from "react";

/**
 * Largura (px) abaixo da qual consideramos o viewport "compacto".
 * Cobre celulares pequenos (320px ~ 379px), onde o layout padrão de mobile
 * ainda sobrepõe elementos (header do chat, FAB e composer).
 */
export const COMPACT_BREAKPOINT = 380;

/**
 * useIsCompactViewport
 * -----------------------------------------------------------------------------
 * Retorna `true` quando a largura da janela é menor que COMPACT_BREAKPOINT.
 * Usado apenas para decisões de renderização (mover botões para menus,
 * iniciar componentes colapsados etc.) — regras de negócio não são afetadas.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-28 v1.0.0 - Criação para suporte a celulares de tela pequena.
 */
export function useIsCompactViewport() {
  const [isCompact, setIsCompact] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${COMPACT_BREAKPOINT - 1}px)`);
    const onChange = () => setIsCompact(window.innerWidth < COMPACT_BREAKPOINT);
    mql.addEventListener("change", onChange);
    setIsCompact(window.innerWidth < COMPACT_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isCompact;
}
